import * as Actions from "../action/CommentLibraryAction";

const initialState = {
  showClModal: false,
  editorListner: false,
};

const CommentLibraryReducer = (state = initialState, action) => {
  switch (action?.type) {
    case Actions.SHOW_CL_MODAL: {
      return { ...state, showClModal: action.payload };
    }
    case Actions.GET_CL_LIST: {
      return { ...state, commentLibraryList: action.payload?.data, totalListCount: action.payload?.total };
    }
    case Actions.GET_CL_TAG_LIST: {
      return { ...state, clTagList: action.payload };
    }
    case Actions.GET_CL_SUMMARY_TAG_LIST: {
      return { ...state, clSummaryTagList: action.payload };
    }
    case Actions.GET_FULL_CL_LIST: {
      return { ...state, commentLibraryWholeList: action.payload?.data };
    }
    case Actions.ADD_NEW_NARRATIVE_COMMENT: {
      state.commentLibraryList.pop();
      return { ...state, totalListCount: state.totalListCount + 1, commentLibraryList: [action.payload, ...state.commentLibraryList] };
    }
    case Actions.EDIT_NARRATIVE_COMMENT: {
      const newList = state.commentLibraryList
      const index = newList.findIndex((item) => item.id === action.payload.comment_id);
      newList[index] = { ...newList[index], ...action.payload, tags: action.payload?.tag_ids, summaries: action.payload?.summary_ids };
      return { ...state, commentLibraryList: newList };
    }
    case Actions.DELETE_NARRATIVE_COMMENT: {
      let deletedCommentList = state.commentLibraryList.filter((item) => item.id !== action.payload);
      return { ...state, commentLibraryList: deletedCommentList, totalListCount: state.totalListCount - 1 };
    }
    case Actions.UPDATE_DROPDOWN_VALUES: {
      return { ...state, [action.payload.key]: action.payload.value };
    }
    case Actions.SET_EDITOR_LISTNER: {
      return { ...state, editorListner: action.payload };
    }
    case Actions.DUPLICATE_COMMENT: {
      let newList = state.commentLibraryList;
      const index = newList.findIndex(item => item.id === action.payload?.id);
      if (index === -1) return newList;
      let updatedArray = [...newList];
      updatedArray.splice(index + 1, 0, action.payload.response);
      return { ...state, commentLibraryList: updatedArray }
    }
    case Actions.SET_IS_HT_COMPANY: {
      return { ...state, isHTCompany: action.payload };
    }
    case Actions.GET_NN_TAG_LIST: {
      return { ...state, clTagList: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default CommentLibraryReducer;